import { GET_TEAMS } from "../actions/types";

const initialState = {
  teams: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_TEAMS:
      return {
        ...state,
        teams: action.payload.results
      };
    default:
      return state;
  }
}
